import { useContext } from "react";
import { fetchAuthSession } from 'aws-amplify/auth';
import AuthContext from "../context/AuthProvider";

const useRefreshToken = () => {
  const { setAuth } = useContext(AuthContext);

  const refresh = async () => {
    try {
      const refreshAccessToken = (await fetchAuthSession({ forceRefresh: true })).tokens?.accessToken.toString();
      setAuth((prev) => ({ ...prev, accessToken: refreshAccessToken })); // Update authentication status with new token
      return refreshAccessToken;
    } catch (error) {
      console.error("Erreur lors du rafraîchissement du token :", error);
    }
  };

  return refresh;
};

export default useRefreshToken;
